import { render, staticRenderFns } from "./LoginRegisterLayout.vue?vue&type=template&id=29d8cc66"
import script from "./LoginRegisterLayout.vue?vue&type=script&lang=js"
export * from "./LoginRegisterLayout.vue?vue&type=script&lang=js"
import style0 from "./LoginRegisterLayout.vue?vue&type=style&index=0&id=29d8cc66&prod&lang=sass"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports